import React, { useEffect, useRef, useState } from 'react';
import { Tooltip, Modal, message } from '@firesoon/antd';
import { SettingFill } from '@firesoon/icons-react';
import { cloneDeep, isEqual } from 'lodash';
import Menu from './Menu';
import './index.less';

const groupName = {
  left: '固定在左侧',
  center: '不固定',
  right: '固定在右侧',
};
// modal witdh
const width = 260;

const sortCol = (cols) => {
  let result: any = {
    left: [],
    center: [],
    right: [],
  };

  cols.forEach((col) => {
    if (col.fixed == null || !result[col.fixed]) {
      result.center.push(col);
    } else {
      result[col.fixed].push(col);
    }
  });

  return result;
};
// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const Index = ({ columns, updateCols, visible, handleDropdown, tableRef, isPopBody }) => {
  const [selectCols, setSelectCols] = useState(sortCol(columns));
  const [tipVisible, setTipVisible] = useState(false);
  const positon = useRef<any>();
  const [checkAll, setCheckAll] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);

  useEffect(() => {
    if (!isEqual(selectCols, columns)) {
      setSelectCols(sortCol(columns));
    }
  }, [columns]);

  useEffect(() => {
    const { left, center, right } = selectCols;
    const cols = [...left, ...center, ...right];
    const checkAll = cols.every((item) => !item.isHide);
    const indeterminate = !checkAll && cols.some((item) => !item.isHide);
    setIndeterminate(indeterminate);
    setCheckAll(checkAll);
  }, [selectCols]);

  const handleCol = (check, col) => {
    const type = col.fixed ?? 'center';
    const cols = cloneDeep(selectCols);
    const index = cols[type].findIndex((item) => item.dataIndex === col.dataIndex);

    // if (index < 0) {
    //   return;
    // }

    cols[type][index].isHide = !check;

    if (col.fixed) {
      cols[type][index].width = getWidth(cols[type][index]);
    }

    setSelectCols({ ...cols });
  };
  const resetCols = () => {
    setSelectCols({ ...sortCol(cloneDeep(columns)) });
    handleDropdown(false);
  };
  /** 计算默认的固定列宽度 */
  const getWidth = ({ title, filters, sorter, width }) => {
    if (width != null) return width;

    let newWidth = title.length * 14 + 16;

    if (filters || sorter) {
      newWidth = width + 28;
    }

    return newWidth;
  };
  const handleGroup = (preFixed, fixed, col) => {
    const item = {
      ...col,
    };
    const index = selectCols[preFixed].findIndex((item) => item.dataIndex === col.dataIndex);

    // if (index < 0) {
    //   return;
    // }

    if (fixed === 'center') {
      delete item.fixed;
    } else {
      item.fixed = fixed;
    }

    selectCols[preFixed].splice(index, 1);
    selectCols[fixed].push(item);

    setSelectCols({ ...selectCols });
  };
  const saveCols = () => {
    const keys = Object.keys(groupName);
    let header = [];

    keys.forEach((key) => {
      let newCols = selectCols[key].map((item) => ({ ...item, isHide: item.noCustom ? false : item.isHide }));
      header = header.concat(newCols);
    });

    if (header.filter((item: any) => !item.isHide && !item.noCustom).length === 0) {
      message.warn('请至少选择一列表头！');
      return;
    }

    updateCols(header);
  };
  const onDragEnd = (result) => {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) {
      return false;
    }

    const items = reorder(selectCols[source.droppableId], source.index, destination.index);

    selectCols[source.droppableId] = items;
    setSelectCols({ ...selectCols });
  };
  const clickSetIcon = (e?) => {
    const x = e?.offsetX || e?.clientX;
    const y = e?.offsetY || e?.clientY;

    if (!visible) {
      handleDropdown(true);
    } else {
      resetCols();
    }

    positon.current = { x, y };
  };
  // eslint-disable-next-line
  const getPopupContainer = () => (isPopBody ? document.body : tableRef ?? document.body);
  const onCheckAllChange = (checked) => {
    const cols = cloneDeep(selectCols);
    Object.keys(cols).forEach((key) => {
      const item = cols[key];
      item.length > 0 &&
        item.forEach((_, index) => {
          cols[key][index].isHide = !checked;
        });
    });
    setSelectCols(cols);
  };
  return (
    <Tooltip
      title="表头自定义"
      placement="top"
      overlayStyle={{ zIndex: 1029, minWidth: 80 }}
      overlayClassName="fs-table-header-set-tip"
      getPopupContainer={getPopupContainer}
      visible={tipVisible}
    >
      <div
        className="fs-table-header-setting"
        onClick={clickSetIcon}
        style={{ cursor: 'pointer' }}
        onMouseEnter={() => setTipVisible(true)}
        onMouseLeave={() => setTipVisible(false)}
      >
        {/* <Icon type="setting" theme="filled" /> */}
        <SettingFill className="fs-table-header-setting-icon" />
      </div>

      {visible && positon.current && (
        <Modal
          logModule="表头自定义"
          visible={!!(visible && positon.current)}
          width={width}
          footer={null}
          closable={false}
          mask={false}
          wrapClassName="fs-table-header-set"
          getContainer={getPopupContainer}
          onCancel={() => clickSetIcon()}
          style={{
            marginLeft: positon.current?.x - width,
            top: positon.current?.y + 4,
          }}
        >
          <Menu
            {...{
              selectCols,
              handleCol,
              resetCols,
              handleGroup,
              saveCols,
              onDragEnd,
              checkAll,
              indeterminate,
              onCheckAllChange,
            }}
          />
        </Modal>
      )}
    </Tooltip>
  );
};

export default Index;
